import * as utils from '@daas-consulting/core-frontend-utils';
import { dateTimeFormatEsAR } from './i18n';

export function formatDate(
  value: string | Date | unknown,
  formatter: Intl.DateTimeFormat = dateTimeFormatEsAR
): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const val = (value as any).toString();
  if (
    utils.date.isDate(value) ||
    /(?:\d{4})-(?:\d{2})-(?:\d{2})T(?:\d{2}):(?:\d{2}):(?:\d{2}).(?:\d{3})Z/i.test(
      val
    )
  ) {
    return formatter.format(new Date(val));
  }

  return value as string;
}
